module.exports = __webpack_public_path__ + "img/item_bookCover_12.d1511569.jpeg";